const ACCOUNT_BG_IMAGES = {
    standard: require('@/assets/images/account/standard.png'),
    advanced: require('@/assets/images/account/advanced.png'),
    professional: require('@/assets/images/account/professional.png'),
    supreme: require('@/assets/images/account/supreme.png'),
    expired: require('@/assets/images/account/expired.png')
}

const VERSION_TIER_KEYS = ['standard', 'advanced', 'professional', 'supreme']

const VERSION_TIER_NAMES = {
    standard: '标准版',
    advanced: '高级版',
    professional: '专业版',
    supreme: '最高级版'
}

/** version_id 1/5 标准，2/6 高级，3/7 专业，4/8 最高级 */
export function resolveAccountBgKeyByVersionId(versionId) {
    const id = Number(versionId)
    if (!id || id < 1 || id > 8) return null
    return VERSION_TIER_KEYS[(id - 1) % 4]
}

export function getVersionNameByVersionId(versionId) {
    const key = resolveAccountBgKeyByVersionId(versionId)
    return key ? VERSION_TIER_NAMES[key] : null
}

export function resolveAccountBgKey(versionName = '') {
    const name = String(versionName).trim()
    if (/至尊|旗舰/.test(name)) return 'supreme'
    if (/企业/.test(name)) return 'professional'
    if (/专业|高级/.test(name)) return 'advanced'
    return 'standard'
}

export function getAccountBg(versionName, isExpired, versionId) {
    const key = isExpired
        ? 'expired'
        : (resolveAccountBgKeyByVersionId(versionId) || resolveAccountBgKey(versionName))
    return ACCOUNT_BG_IMAGES[key] || ACCOUNT_BG_IMAGES.standard
}

export function formatExpireDate(value) {
    if (value == null || value === '') return '—'
    if (value === '终身' || value === '永久') return '终身'
    const date = parseExpireToDate(value)
    if (!date) return String(value)
    const y = date.getFullYear()
    const m = String(date.getMonth() + 1).padStart(2, '0')
    const d = String(date.getDate()).padStart(2, '0')
    return `${y}-${m}-${d}`
}

function parseExpireToDate(value) {
    if (value == null || value === '') return null
    if (value === '终身' || value === '永久') return null
    if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}/.test(value.trim())) {
        const date = new Date(value.trim().replace(/-/g, '/'))
        return Number.isNaN(date.getTime()) ? null : date
    }
    const num = Number(value)
    if (Number.isNaN(num)) return null
    const ms = num > 1e12 ? num : num * 1000
    const date = new Date(ms)
    return Number.isNaN(date.getTime()) ? null : date
}

export function resolveVersionExpireTime(info = {}) {
    if (!info || typeof info !== 'object') return null
    const val = info.version_expire_time ?? info.expire_time ?? info.expires_time
    return val == null || val === '' ? null : val
}

/** 续费时间：原到期日 至 原到期日+year_num年-1天 */
export function getRenewTimeRange(expireTime, yearNum) {
    const startDate = parseExpireToDate(expireTime)
    if (!startDate) return ''
    const years = Number(yearNum) || 1
    const endDate = new Date(startDate)
    endDate.setFullYear(endDate.getFullYear() + years)
    endDate.setDate(endDate.getDate() - 1)
    const startText = formatExpireDate(expireTime)
    const endText = formatExpireDate(endDate.getTime())
    return `续费时间：${startText} 至 ${endText}`
}

export function isVersionPermanent(expireTime) {
    return expireTime == null || expireTime === ''
}

export function formatVersionExpireTime(expireTime) {
    if (isVersionPermanent(expireTime)) return '终身'
    return formatExpireDate(expireTime)
}

export function isVersionExpired(expireTime) {
    if (isVersionPermanent(expireTime)) return false
    const num = Number(expireTime)
    if (Number.isNaN(num)) return false
    const ms = num > 1e12 ? num : num * 1000
    return ms < Date.now()
}

export function isPlatformExpired(info = {}, fallbackExpire) {
    if (info.is_expired === true || info.is_expired === 1 || info.is_expired === '1') {
        return true
    }
    if (info.version_expire_time !== undefined) {
        return isVersionExpired(info.version_expire_time)
    }
    return isAccountExpired(info, fallbackExpire)
}

export function isAccountExpired(info = {}, fallbackExpire) {
    if (info.version_expire_time !== undefined) {
        return isVersionExpired(info.version_expire_time)
    }
    if (Number(info.is_permanent) === 1) return false
    const ts = info.expires_time || info.expire_time || fallbackExpire
    if (!ts) return false
    const num = Number(ts)
    if (Number.isNaN(num)) return false
    const ms = num > 1e12 ? num : num * 1000
    return ms < Date.now()
}
